export default "__VITE_ASSET__B55$TPPR__"